/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Update "Get Better Price | Make Offer" button text and wrap in styled container
(function() {
  var isWrapping = false; // Flag to prevent infinite loops
  
  function wrapBetterPriceButton() {
    // Prevent re-entry
    if (isWrapping) {
      return false;
    }
    
    var button = document.querySelector('.betterPriceLink:not(.better-price-section .betterPriceLink)');
    if (!button) {
      return false;
    }
    
    // Check if button is hidden (sold out, preorder, or backorder)
    var buttonStyle = window.getComputedStyle(button);
    if (buttonStyle.display === 'none' || buttonStyle.visibility === 'hidden') {
      // Hide any existing wrapper
      var existingWrapper = document.querySelector('.better-price-section');
      if (existingWrapper) {
        existingWrapper.style.display = 'none';
      }
      return false;
    }
    
    // Check if already wrapped
    if (button.closest('.better-price-section')) {
      // Still update text in case product type changed
      if (typeof window.productType !== 'undefined') {
        if (window.productType === 'New') {
          button.textContent = 'Get Better Price';
        } else {
          button.textContent = 'Make Offer';
        }
      }
      return true;
    }
    
    isWrapping = true;
    
    try {
      // Set text based on product type
      if (typeof window.productType !== 'undefined') {
        if (window.productType === 'New') {
          button.textContent = 'Get Better Price';
        } else {
          button.textContent = 'Make Offer';
        }
      }
      
      // Store button's parent and position before moving it
      var buttonParent = button.parentNode;
      if (!buttonParent) {
        isWrapping = false;
        return false;
      }
      
      var nextSibling = button.nextSibling;
      
      // Create wrapper structure matching store availability layout
      var wrapper = document.createElement('div');
      wrapper.className = 'better-price-section';
      
      var itemWrapper = document.createElement('div');
      itemWrapper.className = 'better-price-item-wrapper';
      
      // Add icon wrapper (matching store-location-icon structure)
      var iconWrapper = document.createElement('span');
      iconWrapper.className = 'better-price-icon-wrapper';
      
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill', 'currentColor');
      path.setAttribute('d', 'M6.5 14.975v-1H4v-2h5v-2H5q-.425 0-.712-.287T4 8.975v-4q0-.425.288-.712T5 3.975h1.5v-1h2v1H11v2H6v2h4q.425 0 .713.288t.287.712v4q0 .425-.288.713t-.712.287H8.5v1zm7.45 6l-4.25-4.25l1.4-1.4l2.85 2.85l5.65-5.65l1.4 1.4z');
      
      svg.appendChild(path);
      iconWrapper.appendChild(svg);
      
      // Content wrapper (matching store-availability-content structure)
      var contentWrapper = document.createElement('div');
      contentWrapper.className = 'better-price-content';
      
      // Text content wrapper - contains both title and subtitle
      var textContentWrapper = document.createElement('div');
      textContentWrapper.className = 'better-price-text-content';
      
      var title = document.createElement('p');
      title.className = 'better-price-label text--strong';
      title.textContent = 'Want a Better Price?';
      
      var subtitle = document.createElement('div');
      subtitle.className = 'better-price-plan';
      subtitle.textContent = 'Make an offer and save';
      
      textContentWrapper.appendChild(title);
      textContentWrapper.appendChild(subtitle);
      
      // Link wrapper with arrow - styled as button
      var linkWrapper = document.createElement('div');
      linkWrapper.className = 'better-price-link-wrapper';
      
      var linkText = document.createElement('span');
      linkText.className = 'better-price-link-text';
      linkText.textContent = 'Get Better Price';
      
      linkWrapper.appendChild(linkText);
      
      contentWrapper.appendChild(textContentWrapper);
      contentWrapper.appendChild(linkWrapper);
      
      itemWrapper.appendChild(iconWrapper);
      itemWrapper.appendChild(contentWrapper);
      
      wrapper.appendChild(itemWrapper);
      
      // Insert wrapper where button was
      if (nextSibling && nextSibling.parentNode === buttonParent) {
        buttonParent.insertBefore(wrapper, nextSibling);
      } else {
        buttonParent.appendChild(wrapper);
      }
      
      // Check if button should be hidden and hide wrapper if needed
      var buttonStyle = window.getComputedStyle(button);
      if (buttonStyle.display === 'none' || buttonStyle.visibility === 'hidden') {
        wrapper.style.display = 'none';
      }
      
      // Make button (link text) clickable
      linkWrapper.style.cursor = 'pointer';
      linkWrapper.setAttribute('role', 'button');
      linkWrapper.setAttribute('tabindex', '0');
      linkWrapper.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (button.onclick) {
          button.onclick();
        } else {
          button.click();
        }
      });
      linkWrapper.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
      
      // Hide original button but keep in DOM for functionality
      button.style.position = 'absolute';
      button.style.opacity = '0';
      button.style.pointerEvents = 'none';
      button.style.width = '1px';
      button.style.height = '1px';
      wrapper.appendChild(button);
      
      return true;
    } catch (e) {
      console.error('Error wrapping better price button:', e);
      return false;
    } finally {
      isWrapping = false;
    }
  }
  
  // Wait for DOM to be ready
  function init() {
    // Try immediately
    if (wrapBetterPriceButton()) return;
    
    // Retry with intervals (app block may load asynchronously)
    var attempts = 0;
    var maxAttempts = 50;
    var interval = setInterval(function() {
      attempts++;
      if (wrapBetterPriceButton() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also watch for dynamically added buttons, but only check for new buttons
  var observer = new MutationObserver(function(mutations) {
    var hasNewButton = false;
    for (var i = 0; i < mutations.length; i++) {
      var addedNodes = mutations[i].addedNodes;
      for (var j = 0; j < addedNodes.length; j++) {
        var node = addedNodes[j];
        if (node.nodeType === 1) { // Element node
          if (node.classList && node.classList.contains('betterPriceLink')) {
            hasNewButton = true;
            break;
          }
          if (node.querySelector && node.querySelector('.betterPriceLink:not(.better-price-section .betterPriceLink)')) {
            hasNewButton = true;
            break;
          }
        }
      }
      if (hasNewButton) break;
    }
    if (hasNewButton) {
      setTimeout(wrapBetterPriceButton, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Fetch lowest used item price and update link text
(function() {
  function fetchLowestUsedPrice(linkElement) {
    const barcode = linkElement.getAttribute('data-used-barcode');
    const vendor = linkElement.getAttribute('data-used-vendor');
    if (!barcode || barcode.trim() === '') {
      // Hide if no barcode
      const divider = linkElement.closest('.product-form__info-content')?.querySelector('[data-testid="vertical-rule-container"]');
      if (divider) {
        divider.style.setProperty('display', 'none', 'important');
      }
      linkElement.style.display = 'none';
      return;
    }

    // Build search URL - sort by price ascending to get lowest first
    const vendorFilter = vendor ? `&filter.p.vendor=${encodeURIComponent(vendor)}` : '';
    const searchUrl = `/search?sort_by=price_asc&q=${encodeURIComponent(barcode)}&type=product&filter.v.price.gte=&filter.v.price.lte=${vendorFilter}&filter.p.m.custom.acu_product_type=Used&filter.v.availability=1`;
    
    // Fetch search results using section rendering
    fetch(`${searchUrl}&section_id=main-search`)
      .then(response => response.text())
      .then(html => {
        // Parse HTML to extract prices
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find product items in search results - try multiple selectors
        let productItems = doc.querySelectorAll('.product-item');
        if (productItems.length === 0) {
          productItems = doc.querySelectorAll('[class*="product-item"]');
        }
        if (productItems.length === 0) {
          // Try finding products in search results container
          const searchResults = doc.querySelector('.search-results, .product-list, [class*="search"]');
          if (searchResults) {
            productItems = searchResults.querySelectorAll('.product-item, [class*="product"]');
          }
        }
        
        let lowestPrice = null;
        
        productItems.forEach(item => {
          // Look for price elements within each product item - try multiple selectors
          let priceElement = item.querySelector('.price.price--highlight');
          if (!priceElement) {
            priceElement = item.querySelector('.product-item__price-list .price');
          }
          if (!priceElement) {
            priceElement = item.querySelector('.price:not(.price--compare)');
          }
          if (!priceElement) {
            priceElement = item.querySelector('[class*="price"]:not([class*="compare"])');
          }
          
          if (priceElement) {
            const priceText = priceElement.textContent.trim();
            // Extract numeric value (handles formats like $1,234.56 or 1234.56)
            const priceMatch = priceText.match(/[\d,]+\.?\d*/);
            if (priceMatch) {
              // Convert to cents if needed (Shopify prices are often in cents)
              let priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));
              
              // If price seems too large (likely in cents), convert to dollars
              if (priceValue > 10000) {
                priceValue = priceValue / 100;
              }
              
              if (!isNaN(priceValue) && priceValue > 0 && (lowestPrice === null || priceValue < lowestPrice)) {
                lowestPrice = priceValue;
              }
            }
          }
        });

        // Helper function to hide divider and link
        function hideUsedPriceSection() {
          const divider = linkElement.closest('.product-form__info-content')?.querySelector('[data-testid="vertical-rule-container"]');
          if (divider) {
            divider.style.setProperty('display', 'none', 'important');
          }
          linkElement.style.display = 'none';
          
          // Trigger sync event for vertical rule container
          document.dispatchEvent(new CustomEvent('used-link-hidden'));
        }
        
        // If no price found, hide the section
        if (lowestPrice === null) {
          hideUsedPriceSection();
          return;
        }
        
        // Get the current highlight price from the page
        const highlightPriceElement = document.querySelector('.product-form__info-list .price.price--highlight');
        let highlightPrice = null;
        
        if (highlightPriceElement) {
          const highlightPriceText = highlightPriceElement.textContent.trim();
          const highlightPriceMatch = highlightPriceText.match(/[\d,]+\.?\d*/);
          if (highlightPriceMatch) {
            highlightPrice = parseFloat(highlightPriceMatch[0].replace(/,/g, ''));
            // If price seems too large (likely in cents), convert to dollars
            if (highlightPrice > 10000) {
              highlightPrice = highlightPrice / 100;
            }
          }
        }
        
        // If used price is higher than highlight price, hide the divider and link
        if (highlightPrice !== null && lowestPrice > highlightPrice) {
          hideUsedPriceSection();
          // Immediately sync vertical rule container
          setTimeout(function() {
            const verticalRuleContainer = document.querySelector('[data-testid="vertical-rule-container"]');
            if (verticalRuleContainer) {
              verticalRuleContainer.style.setProperty('display', 'none', 'important');
            }
          }, 0);
          return;
        }
        
        // Format price as currency
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(lowestPrice);
        
        // Check if this is the new "Used Starting At" link with placeholder
        const placeholder = linkElement.querySelector('.used-price-placeholder');
        if (placeholder) {
          // Update placeholder for "Used Starting At" link
          placeholder.textContent = formattedPrice;
          // Show the link now that we've successfully updated it
          linkElement.classList.add('used-price-loaded');
          linkElement.style.display = '';
        } else {
          // Original behavior: replace entire content for existing used links
          // Clear existing content
          linkElement.innerHTML = '';
          
          // Create wrapper for the used price display
          const wrapper = document.createElement('div');
          wrapper.className = 'used-price-wrapper';
          
        // Create "Used Starting at" label
        const label = document.createElement('span');
        label.className = 'used-price-label';
        label.textContent = 'Used Starting at';
          
          // Create price container with price and arrow
          const priceContainer = document.createElement('div');
          priceContainer.className = 'used-price-container';
          priceContainer.style.display = 'flex';
          priceContainer.style.alignItems = 'center';
          priceContainer.style.gap = '4px';
          
          // Create price element styled like highlight price
          const priceSpan = document.createElement('span');
          priceSpan.className = 'price price--highlight used-price-value';
          priceSpan.textContent = formattedPrice;
          
          // Create arrow (same as Rent arrow)
          const arrow = document.createElement('span');
          arrow.className = 'used-price-arrow';
          arrow.textContent = '→';
          
          priceContainer.appendChild(priceSpan);
          priceContainer.appendChild(arrow);
          
          wrapper.appendChild(label);
          wrapper.appendChild(priceContainer);
          linkElement.appendChild(wrapper);
        }
        
        // Show the link and divider now that we've successfully updated it
        linkElement.classList.add('used-price-loaded');
        linkElement.style.display = '';
        
        // Show the divider when link is shown
        const divider = linkElement.closest('.product-form__info-content')?.querySelector('[data-testid="vertical-rule-container"]');
        if (divider) {
          divider.style.setProperty('display', 'flex', 'important');
        }
      })
      .catch(error => {
        console.error('Error fetching used item price:', error);
        // Hide the section on error if no results found
        const divider = linkElement.closest('.product-form__info-content')?.querySelector('[data-testid="vertical-rule-container"]');
        if (divider) {
          divider.style.setProperty('display', 'none', 'important');
        }
        linkElement.style.display = 'none';
      });
  }

  function initUsedPriceFetch() {
    // Handle existing used links
    const usedLinks = document.querySelectorAll('a[data-used-link]');
    usedLinks.forEach(link => {
      // Reset: hide link initially (will be shown by JS if price is found and valid)
      link.classList.remove('used-price-loaded');
      link.style.display = 'none';
      
      // Hide divider initially (will be shown by JS if price is found and valid)
      const divider = link.closest('.product-form__info-content')?.querySelector('[data-testid="vertical-rule-container"]');
      if (divider) {
        divider.style.setProperty('display', 'none', 'important');
      }
      
      // Only fetch if link still has default text or hasn't been updated yet
      const hasPriceWrapper = link.querySelector('.used-price-wrapper');
      if (!hasPriceWrapper && (link.textContent.includes('Used Items Available') || link.textContent.trim() === '')) {
        fetchLowestUsedPrice(link);
      } else if (hasPriceWrapper) {
        // Re-check price comparison if already updated (for variant changes)
        fetchLowestUsedPrice(link);
      }
    });
    
    // Handle new "Used Starting At" links
    const usedPriceLinks = document.querySelectorAll('a[data-used-price-link]');
    usedPriceLinks.forEach(link => {
      const placeholder = link.querySelector('.used-price-placeholder');
      if (placeholder && placeholder.textContent === '$...') {
        fetchLowestUsedPrice(link);
      }
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUsedPriceFetch);
  } else {
    initUsedPriceFetch();
  }

  // Also watch for variant changes that might update the link
  document.addEventListener('variant:changed', function() {
    setTimeout(initUsedPriceFetch, 500);
  });

  document.addEventListener('product:rerender', function() {
    setTimeout(initUsedPriceFetch, 500);
  });
})();

// Hide vertical-rule-container when "Used Starting At" button or used link is hidden
(function() {
  function syncVerticalRuleWithUsedButton() {
    const usedButton = document.querySelector('.secondary-button--used');
    const usedLink = document.querySelector('a[data-used-link]');
    const verticalRuleContainer = document.querySelector('[data-testid="vertical-rule-container"]');
    
    if (!verticalRuleContainer) return;
    
    // Check if button is hidden
    const isButtonHidden = usedButton && (
      usedButton.style.display === 'none' || 
      usedButton.offsetParent === null ||
      window.getComputedStyle(usedButton).display === 'none'
    );
    
    // Check if used link is hidden
    const isLinkHidden = !usedLink || (
      usedLink.style.display === 'none' || 
      usedLink.offsetParent === null ||
      window.getComputedStyle(usedLink).display === 'none'
    );
    
    // Hide vertical-rule-container if either button or link is hidden
    if (isButtonHidden || isLinkHidden) {
      verticalRuleContainer.style.setProperty('display', 'none', 'important');
    } else {
      // Only show if both are visible
      verticalRuleContainer.style.setProperty('display', 'flex', 'important');
    }
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(syncVerticalRuleWithUsedButton, 100);
    });
  } else {
    setTimeout(syncVerticalRuleWithUsedButton, 100);
  }
  
  // Also run after variant changes
  document.addEventListener('variant:changed', function() {
    setTimeout(syncVerticalRuleWithUsedButton, 100);
  });
  
  // Watch for changes to the button and link visibility
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        syncVerticalRuleWithUsedButton();
      }
    });
  });
  
  // Observe the used button and link when they're available
  function observeUsedElements() {
    const usedButton = document.querySelector('.secondary-button--used');
    const usedLink = document.querySelector('a[data-used-link]');
    
    if (usedButton) {
      observer.observe(usedButton, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
    
    if (usedLink) {
      observer.observe(usedLink, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observeUsedElements();
      // Also sync after used price fetch completes
      setTimeout(syncVerticalRuleWithUsedButton, 1000);
    });
  } else {
    observeUsedElements();
    setTimeout(syncVerticalRuleWithUsedButton, 1000);
  }
  
  // Also sync after used price fetch completes
  document.addEventListener('product:rerender', function() {
    setTimeout(syncVerticalRuleWithUsedButton, 1000);
  });
  
  // Listen for when used link is hidden
  document.addEventListener('used-link-hidden', function() {
    syncVerticalRuleWithUsedButton();
  });
})();

// Hide product-meta__available-to-rent div if not available to rent AND (no used or used > new)
(function() {
  function checkAndHideAvailableToRent() {
    const availableToRentDiv = document.querySelector('.product-meta__available-to-rent');
    if (!availableToRentDiv) return;
    
    // Check if rental is available
    const rentalLink = availableToRentDiv.querySelector('.available-to-rent-link:not(.used-starting-price-link)');
    const isRentalAvailable = rentalLink && (
      rentalLink.style.display !== 'none' && 
      rentalLink.offsetParent !== null &&
      window.getComputedStyle(rentalLink).display !== 'none'
    );
    
    // Check if used link is visible
    const usedLink = availableToRentDiv.querySelector('.used-starting-price-link');
    const isUsedLinkVisible = usedLink && (
      usedLink.style.display !== 'none' && 
      usedLink.offsetParent !== null &&
      window.getComputedStyle(usedLink).display !== 'none'
    );
    
    // Also check the used link in product-form__info-content
    const usedLinkInInfo = document.querySelector('a[data-used-link]');
    const isUsedLinkInInfoVisible = usedLinkInInfo && (
      usedLinkInInfo.style.display !== 'none' && 
      usedLinkInInfo.offsetParent !== null &&
      window.getComputedStyle(usedLinkInInfo).display !== 'none'
    );
    
    // Hide if: not available to rent AND (no used link visible)
    if (!isRentalAvailable && !isUsedLinkVisible && !isUsedLinkInInfoVisible) {
      availableToRentDiv.style.setProperty('display', 'none', 'important');
    } else {
      availableToRentDiv.style.setProperty('display', '', 'important');
    }
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(checkAndHideAvailableToRent, 1500);
    });
  } else {
    setTimeout(checkAndHideAvailableToRent, 1500);
  }
  
  // Run after variant changes
  document.addEventListener('variant:changed', function() {
    setTimeout(checkAndHideAvailableToRent, 1500);
  });
  
  // Run when used link is hidden
  document.addEventListener('used-link-hidden', function() {
    setTimeout(checkAndHideAvailableToRent, 100);
  });
  
  // Watch for changes to rental and used links
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        checkAndHideAvailableToRent();
      }
    });
  });
  
  function observeLinks() {
    const availableToRentDiv = document.querySelector('.product-meta__available-to-rent');
    if (availableToRentDiv) {
      const rentalLink = availableToRentDiv.querySelector('.available-to-rent-link:not(.used-starting-price-link)');
      const usedLink = availableToRentDiv.querySelector('.used-starting-price-link');
      const usedLinkInInfo = document.querySelector('a[data-used-link]');
      
      if (rentalLink) {
        observer.observe(rentalLink, {
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
      
      if (usedLink) {
        observer.observe(usedLink, {
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
      
      if (usedLinkInInfo) {
        observer.observe(usedLinkInInfo, {
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLinks);
  } else {
    observeLinks();
  }
})();

